// Función para inicializar el botón de sincronización
function initSyncButton() {
  const syncButton = document.getElementById('btn-sync-classrooms');
  
  if (syncButton) {
    // Remover listeners anteriores para evitar duplicados
    syncButton.replaceWith(syncButton.cloneNode(true));
    const newButton = document.getElementById('btn-sync-classrooms');
    
    if (newButton) {
      newButton.addEventListener('click', handleSyncClick);
      console.log('✓ Botón de sincronización inicializado');
    }
  }
}

// Manejador del click del botón
function handleSyncClick(e) {
  e.preventDefault();
  
  const syncButton = document.getElementById('btn-sync-classrooms');
  const schoolId = syncButton.dataset.schoolId || getSchoolIdFromUrl();
  
  if (!schoolId) {
    alert('Error: No se pudo obtener el ID de la escuela');
    return;
  }
  
  syncClassrooms(schoolId);
}

function getSchoolIdFromUrl() {
  // Obtener el ID de la escuela desde la URL
  const match = window.location.pathname.match(/schools\/(\d+)/);
  return match ? match[1] : null;
}

function syncClassrooms(schoolId) {
  const syncButton = document.getElementById('btn-sync-classrooms');
  const originalText = syncButton.innerText;
  
  // Mostrar estado de carga
  syncButton.disabled = true;
  syncButton.innerText = '⏳ Sincronizando...';
  syncButton.classList.remove('btn-warning');
  syncButton.classList.add('btn-info');
  
  fetch(`/schools/${schoolId}/sync_classrooms`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    }
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      showSuccessAlert(data, originalText, syncButton);
      // Recargar la tabla de grupos después de 2 segundos
      setTimeout(() => {
        location.reload();
      }, 2000);
    } else {
      showErrorAlert(data, originalText, syncButton);
    }
  })
  .catch(error => {
    console.error('Error:', error);
    showErrorAlert(
      {
        message: 'Error de conexión: ' + error.message,
        error: error.message
      },
      originalText,
      syncButton
    );
  })
  .finally(() => {
    // Restaurar estado del botón
    syncButton.disabled = false;
    syncButton.innerText = originalText;
    syncButton.classList.remove('btn-info');
    syncButton.classList.add('btn-warning');
  });
}

function getCsrfToken() {
  const token = document.querySelector('meta[name="csrf-token"]');
  return token ? token.getAttribute('content') : '';
}

function showSuccessAlert(data, originalText, syncButton) {
  const classroomsCount = data.classrooms_count || 0;
  const studentsCount = data.students_count || 0;
  
  const alertHtml = `
    <div class="alert alert-success alert-dismissible fade show" role="alert">
      <h4 class="alert-heading">✅ ¡Sincronización Exitosa!</h4>
      <p><strong>${data.message}</strong></p>
      <hr>
      <ul class="mb-0">
        <li>📚 <strong>Grupos sincronizados:</strong> ${classroomsCount}</li>
        <li>👥 <strong>Estudiantes procesados:</strong> ${studentsCount}</li>
      </ul>
      <p class="mb-0 mt-3 text-muted">La página se recargará en 2 segundos...</p>
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  `;
  
  insertAlertAboveCard(alertHtml);
}

function showErrorAlert(data, originalText, syncButton) {
  const errorMsg = data.error || 'Error desconocido';
  
  let errorDetails = '';
  if (typeof errorMsg === 'string') {
    errorDetails = errorMsg;
  } else if (typeof errorMsg === 'object') {
    errorDetails = JSON.stringify(errorMsg);
  }
  
  const alertHtml = `
    <div class="alert alert-danger alert-dismissible fade show" role="alert">
      <h4 class="alert-heading">❌ Error en la Sincronización</h4>
      <p><strong>${data.message}</strong></p>
      <hr>
      <p class="mb-0"><small>${errorDetails}</small></p>
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  `;
  
  insertAlertAboveCard(alertHtml);
}

function insertAlertAboveCard(alertHtml) {
  const card = document.querySelector('.card');
  if (card) {
    const alertDiv = document.createElement('div');
    alertDiv.innerHTML = alertHtml;
    card.parentNode.insertBefore(alertDiv.firstElementChild, card);
    
    // Auto-cerrar el alert después de 8 segundos
    setTimeout(() => {
      const alert = document.querySelector('.alert');
      if (alert) {
        alert.style.transition = 'opacity 0.3s ease-out';
        alert.style.opacity = '0';
        setTimeout(() => alert.remove(), 300);
      }
    }, 8000);
  }
}

// Inicializar cuando el DOM está listo
document.addEventListener('DOMContentLoaded', function() {
  console.log('✓ DOMContentLoaded - Inicializando botón de sincronización');
  initSyncButton();
});

// También inicializar cuando Turbolinks carga una nueva página
document.addEventListener('turbolinks:load', function() {
  console.log('✓ Turbolinks:load - Reinicializando botón de sincronización');
  initSyncButton();
});
